import React, { HTMLProps, RefObject } from 'react'
import { twMerge } from 'tailwind-merge'
import Image from '../../components/Image'

interface SummaryPictureProps extends HTMLProps<HTMLImageElement> {
  slug: string
  imageClassName?: string
  imageRef?: RefObject<HTMLImageElement>
}

const SummaryPicture = ({
    slug,
    className,
    imageClassName,
    alt,
    imageRef,
    ...props
}: SummaryPictureProps) => {
    return (
        <div
            className={twMerge('flex items-center justify-center bg-white p-6 md:p-0 h-full', className)}
        >
            <Image
                slug={slug}
                alt={alt || slug}
                className={twMerge('object-cover object-center aspect-square', imageClassName)}
                imageRef={imageRef}
                {...props}
            />
        </div>
    )
}

export default SummaryPicture
